import { action } from 'mobx';
import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { ActionRegistryItem } from '../../../registry/action/ActionRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class ActionsAssociate extends ActionRegistryCategory {
    label = 'Associate';
    constructor(parent) {
        super(parent);
        super.init();
    }
    associate_setCurrentAssociation = () => new ActionRegistryItem({
        label: 'Als Aktuelle Association setzen',
        action: ({ question, association }) => {
            if (!(question instanceof runtime.solidPackages.Rare.classes.QuestionAssociate))
                return;
            question.manuallySelectedAssociation = association;
        },
    });
    associate_selectOptionIfAssociationDragMatch = () => new ActionRegistryItem({
        label: 'OnDragStop: Dragging Ziel auswählen',
        action: ({ question }) => {
            if (!(question instanceof runtime.solidPackages.Rare.classes.QuestionAssociate))
                return;
            const association = question.currentAssociation;
            if (!association)
                return;
            const option = association.actorIntersect.mainIntersectingActorsOfType('option');
            if (!option || !(option instanceof runtime.solidPackages.Rare.classes.AssociateOption))
                return;
            option.selectOption();
        },
    });
    association_revertDraggableToDefaultPosition = () => new ActionRegistryItem({
        label: 'Revert Draggable to Default Position',
        action: ({ association }) => {
            if (!association)
                return;
            association.inner.aspectDraggable.runtimePosition = association.inner.aspectDraggable.defaultPosition;
            setTimeout(action(() => (association.inner.aspectDraggable.runtimePosition = undefined)), 1500);
        },
    });
    association_flyDraggableToTargetPosition = () => new ActionRegistryItem({
        label: 'Fly Draggable to Center of Target Position',
        action: ({ association }) => {
            if (!association || !association.targetOption)
                return;
            association.inner.aspectDraggable.runtimePosition = {
                x: association.targetOption.inner.aspectMount.measureToInnerStageIncludingTransform.aspectLeftInPixel +
                    0.5 * association.targetOption.inner.aspectMount.mountDimensions.aspectWidthInPixel -
                    0.5 * association.inner.aspectMount.mountDimensions.aspectWidthInPixel,
                y: association.targetOption.inner.aspectMount.measureToInnerStageIncludingTransform.aspectTopInPixel +
                    0.5 * association.targetOption.inner.aspectMount.mountDimensions.aspectHeightInPixel -
                    0.5 * association.inner.aspectMount.mountDimensions.aspectHeightInPixel,
            };
            setTimeout(action(() => (association.inner.aspectDraggable.runtimePosition = undefined)), 1500);
        },
    });
}
